import { render, staticRenderFns } from "./PendingDownload.vue?vue&type=template&id=6fb5c1bf&"
import script from "./PendingDownload.vue?vue&type=script&lang=js&"
export * from "./PendingDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./PendingDownload.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fb5c1bf')) {
      api.createRecord('6fb5c1bf', component.options)
    } else {
      api.reload('6fb5c1bf', component.options)
    }
    module.hot.accept("./PendingDownload.vue?vue&type=template&id=6fb5c1bf&", function () {
      api.rerender('6fb5c1bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PendingDownload.vue"
export default component.exports